import React, { Component } from "react";
import logo from "./logo.svg";
import "bootstrap";
import DataService from "./DataService";

export default class Header extends Component {
  onLogoutClick = () => {
    DataService.logout().then(() => {
      window.location.href = '/';
    })
  }

  render() {
    const { email } = this.props;

    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
        <a className="navbar-brand" href="https://www.logograb.com/backoffice/" title={ 'Build: #' + process.env.VERSION }>
          <img
            src={logo}
            width="30"
            height="30"
            className="d-inline-block align-top"
            alt=""
          />
        </a>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <a className="nav-link" href="#">
                Library
              </a>
            </li>
            <li className="nav-item active">
              <a className="nav-link" href="..">
                Activation
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                Settings
              </a>
            </li>
          </ul>
          <span className="navbar-text dropdown">
            <a className="dropdown-toggle" data-toggle="dropdown" href="#">
              {email}
            </a>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a onClick={this.onLogoutClick} className="dropdown-item" href="#">
                <i className="fa fa-sign-out" aria-hidden="true" /> Logout
              </a>
            </div>
          </span>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Header.js